'use strict';

function allCharsReg(src) {
  return RegExp('[' + src + ']', 'g');
}

module.exports = allCharsReg;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/allCharsReg.js
// module id = 250
// module chunks = 0